import { ColumnData as CD } from 'ui/tableHeader';

export enum REPLY_TYPE {
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
  ORDER = 'ORDER',
  AUDIO = 'AUDIO',
  VOICE = 'VOICE',
  DOCUMENT = 'DOCUMENT',
  INTERACTIVE_PAYMENT_CONFIRMATION = 'INTERACTIVE_PAYMENT_CONFIRMATION',
  INTERACTIVE_BUTTON_REPLY = 'INTERACTIVE_BUTTON_REPLY',
  LOCATION = 'LOCATION',
  TEXT = 'TEXT',
  BUTTON = 'BUTTON',
  INTERACTIVE_LIST_REPLY = 'INTERACTIVE_LIST_REPLY',
  STICKER = 'STICKER',
  CONTACT = 'CONTACT',
}

export type CampaignCustomReplyDefinition = {
  messageType: REPLY_TYPE;
  messageText: string;
  messageUrl?: string;
  userEmail: string;
  createdAt: string;
};

export type ColumnValue = keyof CampaignCustomReplyDefinition;

export type ColumnData = CD & {
  RowCell: ({ row }: { row: CampaignCustomReplyDefinition }) => React.ReactElement;
};
